import { initModule } from './init-module';

initModule();

export { EasyPlanFAQRoutes } from './easy-plan-faq.routes';

export { easyPlanFAQ } from './easy-plan-faq.config';

export { EasyPlanFAQComponent } from './components/easy-plan-faq';
